import React, { useContext, useEffect, useState } from "react";
import "../../../../assets/css/seller/SellerLogin.css";
import logo from "../../../../assets/images/logo.png";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

// ── Store Icon (shop/storefront) ─────────────────────────────────────────────
// const StoreIcon = () => (
//   <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//     <path d="M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921zM17.307 15h-6.64l-2.5-6h11.39l-2.25 6z" />
//     <circle cx="10.5" cy="19.5" r="1.5" />
//     <circle cx="17.5" cy="19.5" r="1.5" />
//   </svg>
// );

// ── Eye / Eye-off Icons ──────────────────────────────────────────────────────
const EyeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

// ── Main Component ────────────────────────────────────────────────────────────
const SellerLogin = ({ onNavigateRegister, onNavigateCustomer }) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  // const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(true);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [resettingPassword, setResettingPassword] = useState(false);
  const navigate = useNavigate();

  const { baseUrl, setLoggedInSeller, regTpChecker } = useContext(AppContext);

  // ── Axios instance with JWT interceptor ──
  // Token key: "sellerToken" — same key used everywhere in this file.
  // Make sure Sellersignup.jsx also saves the token under "sellerToken"
  // (not "jwt_token"), otherwise auto-login here won't find it.
  const api = axios.create({
    baseURL: baseUrl,
  });

  api.interceptors.request.use((config) => {
    const token = localStorage.getItem("sellerToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // ── Manual login (user clicks "Login as Seller") ──
  const loginSeller = () => {
    if (!email || !password) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please enter both email and password.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/seller/auth/login`, { email, password })
      .then((response) => {
        console.log(response.data);
        console.log("LOGIN RESPONSE:", response.data); // TEMP – console check karo
        if (response.data.success) {
          localStorage.setItem("sellerToken", response.data.token);

          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify(response.data.shop),
          );

          navigate("/seller-dashboard");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text:
              response.data.Message ||
              response.data.error ||
              "Invalid credentials",
          });
        }
      })
      .catch((err) => {
        console.log(err);

        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text:
            err.response?.data?.message ||
            "Invalid credentials or server error. Please try again.",
          confirmButtonColor: "#f97316",
        });
      });
  };
  const resetSellerPassword = (e) => {
    e.preventDefault();
      const passwordError = regTpChecker("password", newPassword);

  if (passwordError) {
    Swal.fire({
      icon: "warning",
      title: "Invalid Password",
      text: passwordError,
      confirmButtonColor: "#f97316",
    });
    return;
  }

  if (!confirmPassword) {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please confirm your password.",
      confirmButtonColor: "#f97316",
    });
    return;
  }

  if (newPassword !== confirmPassword) {
    Swal.fire({
      icon: "error",
      title: "Password Mismatch",
      text: "New password and confirm password do not match.",
      confirmButtonColor: "#f97316",
    });
    return;
  }

    if (!newPassword || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please enter both passwords.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "New password and confirm password do not match.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    setResettingPassword(true);

    axios
      .post(`${baseUrl}/seller/auth/resetSellerPassword`, {
        email: email,
        new_password: newPassword,
        confirm_password: confirmPassword,
      })
      .then((response) => {
        setResettingPassword(false);

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Password Reset",
            text: "Your password has been reset successfully.",
            confirmButtonColor: "#f97316",
          });

          setForgotPassword(false);
          setEmailVerified(false);
          setNewPassword("");
          setConfirmPassword("");
          setEmail("");
        }
      })
      .catch((error) => {
        setResettingPassword(false);

        Swal.fire({
          icon: "error",
          title: "Reset Failed",
          text: error.response?.data?.message || "Something went wrong.",
          confirmButtonColor: "#f97316",
        });
      });
  };
  const checkSellerEmail = (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Email Required",
        text: "Please enter your email.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    setCheckingEmail(true);

    axios
      .post(`${baseUrl}/seller/auth/checkSellerEmail`, {
        email: email,
      })
      .then((response) => {
        setCheckingEmail(false);

        if (response.data.success) {
          setEmailVerified(true);
        }
      })
      .catch((error) => {
        setCheckingEmail(false);
        setEmailVerified(false);

        Swal.fire({
          icon: "error",
          title: "Email Not Found",
          text:
            error.response?.data?.message || "This email is not registered.",
          confirmButtonColor: "#f97316",
        });
      });
  };

  // ── Silent auto-login (runs on page load if a saved token exists) ──
  // Verifies the token against the backend instead of re-sending
  // email/password. No Swal popups here — this runs in the background
  // and shouldn't interrupt the user. Token is attached automatically
  // by the api interceptor above, so no manual header needed here.
  const autoLogin = () => {
    api
      .get("/seller/profile")
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          setLoggedInSeller(response.data.admin ?? response.data.shop);
          navigate("/seller-dashboard");
        } else {
          // token invalid/expired — clear stale session
          localStorage.removeItem("sellerToken");
          localStorage.removeItem("loggedInSeller");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        // token invalid/expired — clear stale session
        localStorage.removeItem("sellerToken");
        localStorage.removeItem("loggedInSeller");
        setLoading(false);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("sellerToken");

    if (token) {
      autoLogin();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="sl-page">
      {loading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (
        <Container>
          {/* ── Card ── */}
          <div className="sl-card">
            {/* LOGO */}
            <div className="sidebar-logo">
              <img src={logo} alt="Logo" className="logo-icon" />
            </div>

            {/* ── Heading ── */}
            <div className="sl-heading">
              <h1 className="sl-heading__title">Seller Login</h1>
              <p className="sl-heading__sub">
                Access your seller dashboard and manage your deals
              </p>
            </div>

            <form noValidate>
              {/* Email */}
              <div className="sl-field">
                <label className="sl-label" htmlFor="sl-email">
                  Email Address
                </label>
                <div className="sl-input-wrap">
                  <input
                    id="sl-email"
                    type="email"
                    className="sl-input sl-input--email"
                    placeholder="seller@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
              </div>

              {/* Password - ONLY LOGIN MODE */}
              {!forgotPassword && (
                <div className="sl-field">
                  <label className="sl-label" htmlFor="sl-password">
                    Password
                  </label>

                  <div className="sl-input-wrap">
                    <input
                      id="sl-password"
                      type={showPass ? "text" : "password"}
                      className="sl-input"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      required
                    />

                    <button
                      type="button"
                      className="sl-eye-btn"
                      onClick={() => setShowPass((p) => !p)}
                      aria-label={showPass ? "Hide password" : "Show password"}
                    >
                      {showPass ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                </div>
              )}
               {/* Error Message */}
              {errorMessage && (
                <div className="buyer-error-message">{errorMessage}</div>
              )}
              {/* Success Message */}
              {successMessage && (
                <div className="buyer-success-message">{successMessage}</div>
              )}

              {/* Forgot Password */}
              {!forgotPassword && (
                <div className="sl-row">
                  <button
                    type="button"
                    className="sl-forgot"
                    onClick={() => {
                      setForgotPassword(true);
                      setEmailVerified(false);
                    }}
                  >
                    Forgot Password?
                  </button>
                </div>
              )}

              {/* Check Email */}
              {forgotPassword && !emailVerified && (
                <button
                  type="button"
                  className="sl-submit-btn"
                  onClick={checkSellerEmail}
                  disabled={checkingEmail}
                >
                  {checkingEmail ? "Checking..." : "Continue"}
                </button>
              )}

              {/* New Password + Confirm Password */}
              {forgotPassword && emailVerified && (
                <>
                  {/* New Password */}
                  <div className="sl-field">
                    <label className="sl-label">New Password</label>

                    <div className="sl-input-wrap">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        className="sl-input"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) =>{ setNewPassword(e.target.value)
                          setErrorMessage(
                          regTpChecker("password", e.target.value),
                        );
                        }}
                      />

                      <button
                        type="button"
                        className="sl-eye-btn"
                        onClick={() => setShowNewPassword((p) => !p)}
                        aria-label={
                          showNewPassword
                            ? "Hide new password"
                            : "Show new password"
                        }
                      >
                        {showNewPassword ? <EyeOffIcon /> : <EyeIcon />}
                      </button>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="sl-field">
                    <label className="sl-label">Confirm Password</label>

                    <div className="sl-input-wrap">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="sl-input"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />

                      <button
                        type="button"
                        className="sl-eye-btn"
                        onClick={() => setShowConfirmPassword((p) => !p)}
                        aria-label={
                          showConfirmPassword
                            ? "Hide confirm password"
                            : "Show confirm password"
                        }
                      >
                        {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                      </button>
                    </div>
                  </div>

                  {/* Reset Password */}
                  <button
                    type="button"
                    className="sl-submit-btn"
                    onClick={resetSellerPassword}
                    disabled={resettingPassword}
                  >
                    {resettingPassword ? "Resetting..." : "Reset Password"}
                  </button>
                </>
              )}

              {/* Login Button - ONLY LOGIN MODE */}
              {!forgotPassword && (
                <button
                  type="button"
                  className="sl-submit-btn"
                  onClick={loginSeller}
                >
                  Login as Seller
                </button>
              )}

              {/* Back To Login */}
              {forgotPassword && (
                <div className="text-center mt-3">
                  <button
                    type="button"
                    className="sl-forgot"
                    onClick={() => {
                      setForgotPassword(false);
                      setEmailVerified(false);
                      setNewPassword("");
                      setConfirmPassword("");
                    }}
                  >
                    ← Back to Login
                  </button>
                </div>
              )}
            </form>

            {/* Footer */}
            <div className="sl-footer">
              <p className="sl-footer__register">
                Don't have a seller account?{" "}
                <a
                  href="#register"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/seller-signup");
                  }}
                >
                  Register as Seller
                </a>
              </p>
              <button
                className="sl-footer__customer"
                onClick={onNavigateCustomer}
              >
                ← Login as Customer
              </button>
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

export default SellerLogin;
